import React from 'react'

import { WrenchIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { useConsumedSearchParamState } from '~/client/src/shared/hooks/useConsumedSearchParamState'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { SETUP_TAB_QUERY_KEY } from '../../ProjectSetUpPages'
import EquipmentControls from './EquipmentControls/EquipmentControls'
import EquipmentForms from './EquipmentForms/EquipmentForms'
import EquipmentObjects from './EquipmentObjects/EquipmentObjects'
import EquipmentSetupTabs, { EquipmentTab } from './EquipmentSetupTabs'
import EquipmentProperties from './Properties/EquipmentProperties'

function EquipmentSetup() {
  // ?tab= deep-links into a sub-tab (from the resource picker) and is cleared
  // once consumed so a later refresh keeps the user's last selected tab.
  const [activeTab, setActiveTab] = useConsumedSearchParamState(
    SETUP_TAB_QUERY_KEY,
    Object.values(EquipmentTab),
    EquipmentTab.Objects,
  )

  const renderTabContent = () => {
    switch (activeTab) {
      case EquipmentTab.Objects:
        return <EquipmentObjects />
      case EquipmentTab.Controls:
        return <EquipmentControls />
      case EquipmentTab.Forms:
        return <EquipmentForms />
      case EquipmentTab.Properties:
        return <EquipmentProperties />
      default:
        return null
    }
  }

  return (
    <div className="tw:flex tw:flex-col tw:h-full">
      <div className="tw:flex tw:items-center tw:py-1.5 tw:my-2.5">
        <WrenchIcon className="tw:grow-0 tw:mr-[5px]" />
        <span className="tw:text-title-lg tw:font-semibold tw:text-foreground tw:grow-0 tw:whitespace-nowrap">
          {Localization.translator.equipment}
        </span>
      </div>
      <EquipmentSetupTabs activeTab={activeTab} onTabClick={setActiveTab} />
      <div className="tw:flex-1 tw:min-h-0">{renderTabContent()}</div>
    </div>
  )
}

export default observer(EquipmentSetup)
